import { gql } from '@apollo/client/core'

// ===== MEAL MUTATIONS =====
export const CREATE_MEAL = gql`
  mutation CreateMeal(
    $title: String!
    $description: String
    $recipe_id: ID!
    $type_id: ID!
    $scheduled_date: String!
    $scheduled_dates: [String!]
    $portions_days: Int
    $portions_mode: String
  ) {
    createMeal(
      data: {
        title: $title
        description: $description
        recipe_id: $recipe_id
        type_id: $type_id
        scheduled_date: $scheduled_date
        scheduled_dates: $scheduled_dates
        portions_days: $portions_days
        portions_mode: $portions_mode
      }
    ) {
      id
      title
      description
      recipe_id
      type_id
      scheduled_date
      scheduled_dates
      portions_days
      portions_mode
      created_at
      updated_at
    }
  }
`

export const UPDATE_MEAL = gql`
  mutation UpdateMeal(
    $id: String!
    $title: String!
    $description: String
    $recipe_id: ID!
    $type_id: ID!
    $scheduled_date: String!
    $scheduled_dates: [String!]
    $portions_days: Int
    $portions_mode: String
  ) {
    updateMeal(
      id: $id
      data: {
        title: $title
        description: $description
        recipe_id: $recipe_id
        type_id: $type_id
        scheduled_date: $scheduled_date
        scheduled_dates: $scheduled_dates
        portions_days: $portions_days
        portions_mode: $portions_mode
      }
    ) {
      id
      title
      description
      recipe_id
      type_id
      scheduled_date
      scheduled_dates
      portions_days
      portions_mode
      created_at
      updated_at
    }
  }
`;

export const DELETE_MEAL = gql`
  mutation DeleteMeal($id: String!) {
    deleteMeal(id: $id)
  }
`

export const CREATE_MEAL_TYPE = gql`
  mutation CreateMealType(
    $name: String!
    $time: String
  ) {
    createMealType(
      data: {
        name: $name
        time: $time
      }
    ) {
      id
      name
      time
    }
  }
`

export const UPDATE_MEAL_TYPE = gql`
  mutation UpdateMealType($id: ID!, $data: UpdateMealTypeInput!) {
    updateMealType(id: $id, data: $data) {
      id
      name
      time
    }
  }
`

export const DELETE_MEAL_TYPE = gql`
  mutation DeleteMealType($id: ID!) {
    deleteMealType(id: $id)
  }
`

export const REUSE_MEAL_PLAN = gql`
  mutation ReuseMealPlan($mealIds: [ID!]!, $targetStartDate: String!) {
    reuseMealPlan(meal_ids: $mealIds, target_start_date: $targetStartDate) {
      id
      title
      description
      recipe_id
      type_id
      scheduled_date
      scheduled_dates
      portions_days
      portions_mode
      is_active
      created_at
      updated_at
    }
  }
`

export const SAVE_MEAL_LIST = gql`
  mutation SaveMealList($start_date: String!, $end_date: String!) {
    saveMealList(start_date: $start_date, end_date: $end_date) {
      content
      description
      labels
      due_date
    }
  }
`

// ===== RECIPE MUTATIONS =====
export const CREATE_RECIPE = gql`
  mutation CreateRecipe($data: AddRecipe) {
    createRecipe(data: $data) {
      id
      title
      slug
      description
      content
       category {
        id
        name
        created_at
        updated_at
      }
      created_at
      updated_at
      ingredients {
        id
        name
        type
        quantity
        unit
        created_at
        updated_at
        group {
          id
          name
          created_at
          updated_at
        }
      }
    }
  }
`

export const UPDATE_RECIPE = gql`
  mutation UpdateRecipe(
    $id: String!
    $title: String!
    $description: String
    $content: String
    $category: String
    $ingredients: [UpdateRecipeIngredientInput]
  ) {
    updateRecipe (
      data: {
        title: $title
        description: $description
        content: $content
        category: $category
        ingredients: $ingredients
      },
      id: $id
    ) {
      title
      description
      content
      category {
            id
            name
            created_at
            updated_at
        }
      updated_at
      ingredients {
        id
        name
        type
        quantity
        unit
        created_at
        updated_at
        group {
          id
          name
          created_at
          updated_at
        }
      }
    }
  }
`

export const DELETE_RECIPE = gql`
  mutation DeleteRecipe($id: String!) {
    deleteRecipe(id: $id)
  }
`

// ===== SHOPPING LIST MUTATIONS =====
export const CREATE_SHOPPING_LIST = gql`
  mutation CreateShoppingList(
    $title: String!
    $start_date: String!
    $end_date: String!
  ) {
    createShoppingList(
      title: $title
      start_date: $start_date
      end_date: $end_date
    ) {
      id
      title
      start_date
      end_date
      status
      total_price
      created_at
      updated_at
      items {
        id
        name
        quantity
        unit
        price
        is_bought
      }
    }
  }
`

export const SYNC_SHOPPING_LIST = gql`
  mutation SyncShoppingList(
    $title: String!
    $start_date: String!
    $end_date: String!
    $excluded_meal_ids: [String]
    $excluded_ingredient_ids: [String]
  ) {
    syncShoppingList(
      title: $title
      start_date: $start_date
      end_date: $end_date
      excluded_meal_ids: $excluded_meal_ids
      excluded_ingredient_ids: $excluded_ingredient_ids
    ) {
      id
      title
      start_date
      end_date
      status
      total_price
      created_at
      updated_at
      items {
        id
        name
        quantity
        unit
        price
        is_bought
      }
    }
  }
`
export const UPDATE_SHOPPING_LIST = gql`
  mutation UpdateShoppingList(
    $id: String
    $title: String
    $start_date: String
    $end_date: String
    $status: String
    $total_price: Int
  ) {
    updateShoppingList(
      id: $id
      data: {
        title: $title
        start_date: $start_date
        end_date: $end_date
        status: $status
        total_price: $total_price
      }
    ) {
      id
      title
      start_date
      end_date
      status
      total_price
      created_at
      updated_at
      items {
        id
        name
        quantity
        unit
        price
        is_bought
      }
    }
  }
`

export const DELETE_SHOPPING_LIST = gql`
  mutation DeleteShoppingList($id: String!) {
    deleteShoppingList(id: $id)
  }
`

// ===== SHOPPING ITEM MUTATIONS =====
export const CREATE_SHOPPING_ITEM = gql`
  mutation CreateShoppingItem(
    $list_id: String!
    $name: String!
    $ingredient_id: String!
    $quantity: Float!
    $unit: String!
    $price: Float!
    $type: String!
    $position: Int
  ) {
    createShoppingItem(
      data: {
        list_id: $list_id
        name: $name
        ingredient_id: $ingredient_id
        quantity: $quantity
        unit: $unit
        price: $price
        type: $type
        position: $position
      }
    ) {
      id
      name
      list_id
      list_name
      ingredient_id
      quantity
      unit
      price
      type
      is_bought
      position
      created_at
      updated_at
    }
  }
`

export const UPDATE_SHOPPING_ITEM = gql`
  mutation UpdateShoppingItem(
    $id: String!
    $list_id: String
    $name: String
    $ingredient_id: String
    $quantity: Float
    $unit: String
    $price: Float
    $type: String
    $is_bought: Boolean
    $position: Int
  ) {
    updateShoppingItem(
      id: $id
      data: {
        list_id: $list_id
        name: $name
        ingredient_id: $ingredient_id
        quantity: $quantity
        unit: $unit
        price: $price
        type: $type
        is_bought: $is_bought
        position: $position
      }
    ) {
      id
      name
      list_id
      list_name
      ingredient_id
      quantity
      unit
      price
      type
      is_bought
      position
      created_at
      updated_at
    }
  }
`

export const DELETE_SHOPPING_ITEM = gql`
  mutation DeleteShoppingItem($id: String!) {
    deleteShoppingItem(id: $id)
  }
`

// ===== INGREDIENT MUTATIONS =====
export const CREATE_INGREDIENT = gql`
  mutation CreateIngredient(
    $name: String!
    $type: String!
    $group: String!
  ) {
    createIngredient(
      data: {
        name: $name
        type: $type
        group: $group
      }
    ) {
      id
      name
      type
      quantity
      unit
      created_at
      updated_at
      group {
        id
        name
        created_at
        updated_at
      }
    }
  }
`

export const UPDATE_INGREDIENT = gql`
  mutation UpdateIngredient(
    $id: ID!
    $name: String!
    $type: String!
    $group: String!
  ) {
    updateIngredient(
      id: $id
      data: {
        name: $name
        type: $type
        group: $group
      }
    ) {
      id
      name
      type
      quantity
      unit
      created_at
      updated_at
      group {
        id
        name
        created_at
        updated_at
      }
    }
  }
`

export const DELETE_INGREDIENT = gql`
  mutation DeleteIngredient($id: ID!) {
    deleteIngredient(id: $id)
  }
`

// ===== TASK MUTATIONS =====
export const CREATE_TASK = gql`
  mutation CreateTask(
    $content: String!
    $description: String!
    $due_date: String!
  ) {
    createTask(
      input: {
        content: $content
        description: $description
        due_date: $due_date
      }
    ) {
      id
      content
      project_id
      section_id
      description
      due_date
      labels
    }
  }
`
